import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { videoApi } from "../../../config/videoApi";
import { pages } from "../../../constants/PagePaths";
import styles from "../mainRedesign.module.scss";

export const lectureModels = [
  {
    id: 8,
    title: "계약,기성,준공 내역서강의",
    category: "건설실무",
    userCount: 230,
  },
  {
    id: 7,
    title: "조경설계 올인원",
    category: "조경",
    userCount: 160,
  },
  {
    id: 9,
    title: "토목 포장공사 강의",
    category: "토목",
    userCount: 190,
  },
  {
    id: 6,
    title: "조경 기본",
    category: "조경",
    userCount: 250,
  },
  {
    id: 3,
    title: "조경 식재",
    category: "조경",
    userCount: 250,
  },
  {
    id: 4,
    title: "조경 시설물",
    category: "조경",
    userCount: 170,
  },
  {
    id: 5,
    title: "조경 설계 변경",
    category: "조경",
    userCount: 140,
  },
  {
    id: 10,
    title: "돌담쌓기(겹담+외담)초급강의",
    category: "석공사",
    userCount: 30,
  },
];

export const lectureCategories = [
  "건설실무",
  "조경",
  "토목",
  "석공사",
  "건축(준비중)",
  "전기(준비중)",
];

export default () => {
  const history = useHistory();
  const [lectures, setLectures] = useState<any>([]);

  useEffect(() => {
    getCourse();
  }, []);

  const getCourse = async () => {
    try {
      const res = await videoApi.getCourseListAsync();
      res.data.courses.sort((a: any, b: any) =>
        a.order < b.order ? -1 : a.order > b.order ? 1 : 0
      );
      // Show top 3 by default order
      const orderedCourses = lectureModels
        .slice(0, 3)
        .map((lectureModel) =>
          res.data.courses.find((course: any) => course.id === lectureModel.id)
        )
        .filter(Boolean);
      setLectures(orderedCourses);
    } catch (e) {
      console.error("Failed to load courses:", e);
    }
  };

  return (
    <section className={styles.lectureSection}>
      <div className={styles.sectionInner}>
        <div className={styles.lectureHeader}>
          <h2 className={styles.lectureTitle}>콘엑스 인기 강의</h2>
          <a href={pages.video} className={styles.lectureMore}>
            더보기
            <span className="material-symbols-outlined" style={{ fontSize: 16 }}>
              arrow_forward
            </span>
          </a>
        </div>

        <div className={styles.lectureGrid}>
          {lectures.length > 0 ? (
            lectures.map((lecture: any) => (
              <div
                key={lecture?.id}
                className={styles.lectureCard}
                onClick={() =>
                  history.push(`video/curriculum/${lecture?.id}`)
                }
              >
                <img
                  src={lecture?.card_image}
                  className={styles.lectureImage}
                  alt={lecture?.title}
                />
                <div className={styles.lectureBody}>
                  <div className={styles.lectureItemTitle}>
                    {lecture?.title}
                  </div>
                  <div className={styles.lectureDesc}>
                    {lecture?.description}
                  </div>
                  <div className={styles.lectureMeta}>
                    <div className={styles.lecturePrice}>
                      {lecture?.origin_amount != null &&
                        lecture.origin_amount !== lecture.amount && (
                          <span className={styles.lecturePriceOriginal}>
                            {lecture.origin_amount.toLocaleString()}원
                          </span>
                        )}
                      {lecture?.amount?.toLocaleString()}원
                    </div>
                    <div className={styles.lectureBadges}>
                      <span className={styles.lectureBadge}>
                        {
                          lectureModels.find((m) => m.id === lecture?.id)
                            ?.userCount
                        }
                        명
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className={styles.lectureEmpty}>강의를 불러오는 중...</div>
          )}
        </div>
      </div>
    </section>
  );
};
